import React from 'react';
import { Input, FormGroup } from 'reactstrap';
import CustomerForm from './customer';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from './reducer';
import saga from './saga';

import { searchCustomer } from './actions';
import { makeSelectSearchingCustomer, makeSelectCustomer } from './selectors';

import * as Validator from '../CarQuote/validator';

import UserIcon from '-!svg-react-loader!./assets/img/user.svg?name=UserIcon';

import './offer.scss';

class OfferForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fiscalCode: '',
      fiscalCodeHasError: false,
    };
  }

  onFiscalCodeChange = e => {
    const fiscalCode = e.target.value.trim().toUpperCase();
    this.setState({ fiscalCode });
    if (fiscalCode.length === 16 && Validator.validateFiscalCode(fiscalCode)) {
      this.setState({ fiscalCodeHasError: false });
      this.props.searchCustomer(fiscalCode);
    } else if (
      fiscalCode.length === 16 &&
      !Validator.validateFiscalCode(fiscalCode)
    ) {
      this.setState({ fiscalCodeHasError: true });
    }
  };

  render() {
    const { isSearching, customer } = this.props;
    const { fiscalCode, fiscalCodeHasError } = this.state;
    const hasCustomer =
      customer !== undefined && customer.hasOwnProperty('fiscal_code');
    return (
      <div id="OfferForm">
        <div className="form-title">
          Crea nuovo preventivo relativo all’offerta visualizzata
        </div>
        <div className="form-content">
          <FormGroup className="fiscal-code-input form-user">
            <UserIcon />
            <Input
              name="fiscal_code_input"
              id="fiscal_code_input"
              value={fiscalCode}
              placeholder="Inserisci il codice Fiscale del Cliente per iniziare"
              invalid={fiscalCodeHasError}
              onChange={this.onFiscalCodeChange}
              autoComplete="off"
            />
          </FormGroup>
          {fiscalCodeHasError && (
            <div className="help-block form-text has-error form-control-feedback">
              Il Codice Fiscale inserito non &egrave; valido
            </div>
          )}
          {hasCustomer ? (
            <CustomerForm
              title="Crea un nuovo preventivo"
              customer={customer}
              fiscalCode={fiscalCode}
            />
          ) : (
            <CustomerForm
              title="Crea un nuovo preventivo"
              fiscalCode={fiscalCode}
            />
          )}
        </div>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    searchCustomer: code => dispatch(searchCustomer(code)),
  };
}

const mapStateToProps = createStructuredSelector({
  isSearching: makeSelectSearchingCustomer(),
  customer: makeSelectCustomer(),
});

const withReducer = injectReducer({ key: 'forms', reducer });
const withSaga = injectSaga({ key: 'forms', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(OfferForm);
